import { Component, EventEmitter, OnInit, Output, TemplateRef, ViewChild } from "@angular/core";
import { MatDialog, MatDialogConfig, MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { Contact, ContactInfo } from "src/app/models/contact.model";
import { ContactService } from "../../services/contact/contact.service";
import { StorageService } from "../../services/storage/storage.service";

@Component({
  selector: 'cgu-dialog',
  templateUrl: './cgu.component.html'
})
export class CGUDialogComponent implements OnInit {
  hasAccepted = false;
  dialogRef?: MatDialogRef<any>;
  contact!: ContactInfo;
  updating = false;

  @Output() close = new EventEmitter<boolean>();

  @ViewChild('cguDialog') cguDialog!: TemplateRef<any>;

  constructor(private _storage: StorageService, private _contact: ContactService,private _router: Router, private _dialog: MatDialog) {}

  ngOnInit(): void {
    this.openCGU();
  }

  /**
   * Opens the CGU dialog if the CGU are not accepted yet.
   * @returns None
   */
  async openCGU() {
    try {
      this.contact = await this._storage.getContactInfo();
      if (this.contact &&  !this.contact.cguAcceptanceDate) {
        let config: MatDialogConfig = new MatDialogConfig();
        config.maxWidth = '850px';
        config.disableClose = true;
        config.closeOnNavigation = false;
        this.dialogRef = this._dialog.open(this.cguDialog, config);
      }
    } catch (err) {
      console.error(err);
    }
  }

  /**
   * Closes the dialog and updates the contact's CGU acceptance date.
   * @returns None
   */
  async closeCGU() {
    if(this.dialogRef && this.hasAccepted === true) {
      try {
        this.updating = true;
        const cguAcceptanceDate = await this._contact.acceptCGU();
        this._storage.updateContactInfo({...this.contact, cguAcceptanceDate});
        //this._router.navigateByUrl('/mes-gln');
      } finally {
        this.updating = false;
        this.close.emit(true);
        this.dialogRef.close();
      }
    }
  }

}
